import lang from "@/views/modules/Notifications/language/en";

export default {
    name: "new-notification",
    components: {
    },
    data() {
        return {
            loading: true,
            notification: {},
            lang:[],
        }
    },
    mounted() {
        this.getNotifications();
        this.lang = lang;
    },
    methods: {
        saveNotification() {
            const self = this;
            self.loading = true;
            axios.post('api/modules/notifications', self.notification).then(function (response) {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/notifications/' + response.data.notification.id + '/edit');
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}